import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import WaveSurfer from 'wavesurfer.js';
// import CursorPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js';
import PlaybackButton, {DoPlay} from '../components/buttons/playback';
import Waveform from '../components/waveform';
import { tspan } from '../utils/i18n';
import {TitleText} from "./start";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPause, faPlay} from "@fortawesome/pro-solid-svg-icons";
import {ColoredFooter} from './mic-check';
import {BottomText} from './recording';
import {PrivacyText} from './send-vox'
import { pauseRecButton, playRecButton, forwardButton } from '../utils/alt-tags';

const queryString = require('query-string');

const RecordAgain = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #2E394F;
`;

const PlaybackContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    .buttons {
        flex-direction: row !important;
        justify-content: space-evenly !important;

        ${props => props.pluginMode && css`
            span {
                min-height: 2.5rem;
            }
        `}
    }
`;

export const Play = ({ isPlaying, onPlay, size }) => (
    // !isMobile.iOS() ? (
    <DoPlay style={{marginLeft:'50px'}} onClick={onPlay}>
        <FontAwesomeIcon title={isPlaying ? pauseRecButton : playRecButton} size={size} icon={isPlaying ? faPause : faPlay} />
    </DoPlay>
    // ) : null
)

class Playback extends Component {
    static propTypes = {

    }
    state = {
        wavesurfer: null,
        playing: false,
        sourceType: '',
        processing: true,
        currentTime: 0,
        totalDuration: 0,
    }

    componentDidMount() {
        // A blob-url on the prop is a must
        const { query } = queryString.parseUrl(window.location.href);
        const { blob, url, settings: { common }, audioContext } = this.props;
        if (url) {
            const wavesurfer = WaveSurfer.create({
                container: '#waveform',
                backend: 'MediaElement',
                hideScrollbar: true,
                fillParent: true,
                scrollParent: false,
                barWidth: 4,
                barGap: 0,
                waveColor: '#C4C4C4',
                progressColor: common.linearGradient,
                interact: true,
                barHeight: 1.5, // the height of the wave
                barRadius: 4,
                // partialRender: true,
                mediaType: 'audio',
                normalize: true,
                height: 102,
                audioContext,
                audioScriptProcessor: null,
                backgroundColor: '#fff',
                // plugins: [
                //     CursorPlugin.create({
                //         opacity: 0.2,
                //         customShowTimeStyle: {
                //         }
                //     })
                // ]
            });
            wavesurfer.load(url);
            // wavesurfer.loadBlob(blob);
            this.setState({ wavesurfer });
            setTimeout(() => {
                const timer = wavesurfer.getDuration();
                this.setState({
                  totalDuration: parseInt(timer),
                });
            }, 1500);
            wavesurfer.on('pause', () => {
                (wavesurfer.interact &&
                    this.setState({ playing: false })
            )
            });
            wavesurfer.on('finish', () => {
                this.setState({playing: false});
            })
        }
        if(query && query.reply === 'reply'){
          this.setState({ sourceType:  query.reply });
        }
        const wave = document.getElementById('waveform').getElementsByTagName( 'wave');
        if(wave[1] && navigator.userAgent.match(/Windows/i) && navigator.userAgent.match(/Chrome/i)) {
            wave[1].style.zIndex = '2';
        }
    }

    getTheCurrentTime = () => {
        const {wavesurfer} = this.state;
        const _this = this;
        if (wavesurfer) {
            wavesurfer.on('audioprocess', function () {
                if (wavesurfer.isPlaying() && parseInt(wavesurfer.getCurrentTime()) !== _this.state.currentTime) {
                    _this.setState({currentTime: parseInt(wavesurfer.getCurrentTime())})
                }
            });
        }
    };

    timeLimitString(secondsLimit) {

        let resultM = 0, // In minutes
            resultS = secondsLimit; // In seconds

        // Starting with 2 minutes
        if (resultS > 59) {
            resultM = Math.floor(resultS / 60); // In minutes
            resultS = resultS % 60; // Remainder seconds
        }
        resultS = Math.round(resultS);
        { resultS < 10 ? resultS ='0' + resultS : resultS = resultS }
        return `${resultM ? (resultM) : '00'}${resultS ? ':'+resultS : ':00'}`
    }


    revert() {
        const { onSwitch } = this.props;
        const { wavesurfer } = this.state;

        // Clean up
        wavesurfer.destroy();

        // Return to mic-check to initiate the flow
        onSwitch('mic-check', { countdown: 3 });
    }

    playClip() {
        const { wavesurfer } = this.state;

        // Pause the wave
        wavesurfer.playPause();

        // Force a re-render
        this.setState({ playing: wavesurfer.isPlaying() });
    }

    proceed() {
        const { blob, url, onSwitch, tagOptions } = this.props;
        const { common } = this.props.settings;
        const { wavesurfer } = this.state;

        // Hold on to the duration of the clip for future use
        const duration = wavesurfer.getDuration();

        // Clean up
        wavesurfer.destroy();

        // Just in case (this shouldn't really be needed though.
        // A page switch means the component will unmount. I'm just paranoid.)

        this.setState({ wavesurfer: null, duration });

        // Switch, with props
        common.isContactSkip ?
                onSwitch('send-vox', { blob, url, duration })
            :
                onSwitch('contact', { blob, url, duration, tagOptions })

    }

    toggleLoader = () => {
        this.setState({ processing: false })
    };

    render() {
      const { pluginMode } = this.props;
      const { common } = this.props.settings;
      const { playing, sourceType, wavesurfer, processing,currentTime, totalDuration } = this.state;
        this.getTheCurrentTime()
      return (
        <PlaybackContainer pluginMode={pluginMode}>
          <div className="content">
            {/* Title for the playback page */}
            {/* {!isMobile.iOS() ? ( */}
            {sourceType !== 'reply'
              ? (
                <>
                    <div className="plugin-header">
                  <div
                    className="title"
                    style={{
                        fontFamily: 'Titillium Web',
                        color: common.fontColor,
                        wordBreak:'break-word',
                        whiteSpace: 'pre-wrap',
                    }}
                  >
                      <TitleText>
                          {tspan('playbackTitle')}

                          {/*{pluginMode*/}
                    {/*  ? tspan('plugin-playback-main')*/}
                    {/*  : tspan('playbackTitle', {*/}
                    {/*    playButton: <PlaybackButton isPlaying={false} />,*/}
                    {/*    break: <br />,*/}
                    {/*  })}*/}
                      </TitleText>
                  </div>
                    </div>
                  {/* ) : null} */}

                  {/* Subtitle */}
{/*                  {!pluginMode ? (*/}
{/*                    <div*/}
{/*                      className="sub-title"*/}
{/*                      style={{*/}
{/*  fontFamily: common.fontFamily,*/}
{/*  color: common.fontColor,*/}
{/*}}*/}
{/*                    >*/}

{/*                      {*/}
{/*                                        tspan('playbackSubTitle', {*/}
{/*                                          forwardButton: <Forward />,*/}
{/*                                          backButton: <Back />,*/}
{/*                                          break: <br />,*/}
{/*                                        })*/}
{/*                                    }*/}
{/*                    </div>*/}
{/*                  ) : null}*/}
                </>
              )
              : (
                <div className="title">
                  <RecordAgain>Record again, play back or continue</RecordAgain>
                </div>
              )}
              <div className="sub-title"
                   style={{
                       fontStyle: 'normal',
                       fontFamily: 'Titillium Web',
                       fontWeight: 'normal',
                       fontSize: '15px',
                       lineHeight: '23px',
                       color:'#27364E',
                       marginTop:`${pluginMode ? "10px" : "0"}`,
                       wordBreak:'break-word',
                       whiteSpace: 'pre-wrap',
                   }}>
                  {
                      tspan('playbackSubTitle')
                  }
              </div>

            {/* Waveform, and properties */}

              <div className="content-footer">

              <Waveform details={false} pluginMode={pluginMode}  toggleLoader={this.toggleLoader} />
                  <div style={{
                      display: 'flex',
                      width: '75%',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      margin:'0.5rem auto',
                  }}>
                      <i className=''  style={{visibility:'hidden'}}></i>
                      <Play size="2x" isPlaying={playing} onPlay={() => this.playClip()}/>
                      <label style={{fontFamily: 'Titillium Web',
                          display:'flex',
                          justifyContent:'flex-end',
                          fontSize: '10px',
                          lineHeight: '15px',
                          textAlign: 'right',

                      }}>{wavesurfer !== null &&  this.timeLimitString(currentTime)}
                          /
                          {wavesurfer !== null &&  this.timeLimitString(totalDuration)}
                      </label>

                  </div>
                  <PrivacyText style={{visibility:'hidden'}}/>
              </div>

          </div>

            <BottomText>Press to proceed</BottomText>
          {/* Buttons */}
          {wavesurfer ? (
            <ColoredFooter className="buttons" requiredShadow={common.requiredShadow} hideGreyBar={common.hideGreyBar}>
              <PlaybackButton common={common} size="2x" onBack={() => this.revert()}
                              onPlay={() => this.playClip()} onForward={() => this.proceed()} isPlaying={playing}
                              micPermission={true} processing={processing} title={forwardButton}/>
            </ColoredFooter>
          ) : null}
        </PlaybackContainer>
      );
    }
}
export default Playback;
